"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCandidateAnswer = useCandidateAnswer;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function useCandidateAnswer(candidateId, questionId) {
    const candidatesAnswers = (0, stores_1.useCalculatorStore)((state) => state.data.candidatesAnswers);
    return (0, react_1.useMemo)(() => {
        const candidateAnswers = candidatesAnswers[candidateId];
        if (!candidateAnswers)
            return undefined;
        const answer = candidateAnswers.find((answer) => answer.questionId === questionId);
        return answer ? (0, view_models_1.candidateAnswerViewModel)(answer) : undefined;
    }, [candidatesAnswers, candidateId, questionId]);
}
